import * as React from 'react';
import { Dispatch } from 'redux';
import { ParticipantViewModel } from 'stageclip-common';

import { BaseApiPutRequest } from '../generic/baseApiPutRequest';
import * as EntityNormalizers from '../normalizers/entityNormalizers';
import * as ParticipantNormalizers from '../normalizers/participantNormalizers';

export class UploadEventParticipantsWithEventSplit extends BaseApiPutRequest<
  ParticipantViewModel,
  EntityNormalizers.NormalizedEntityArray<ParticipantNormalizers.NormalizedParticipants>
> {
  constructor(
    eventId: string,
    private uploadParticipantsFormData: any,
    component: React.Component,
    dispatch: Dispatch,
  ) {
    super(uploadParticipantsFormData, component, dispatch);
    this.path = `/events/${eventId}/split-participants`;
    this.normalizeMethod = ParticipantNormalizers.normalizeParticipantsArray;
    this.method = 'PATCH';
  }

  protected generateRequest() {
    const request = super.generateRequest();
    const data = new FormData();
    data.append('participantsFile', this.uploadParticipantsFormData.participantsFile);
    request.body = data;

    return request;
  }

  protected generateHeaders() {
    const headers = super.generateHeaders();
    headers.delete('Content-type');

    return headers;
  }
}
